<template>
  <b-nav pills vertical>
    <b-nav-item :to="{name: 'company-profile'}"><translate>Company Profile</translate></b-nav-item>
    <b-nav-item v-if="!isSelfService" :to="{name: 'company-settings'}"><translate>Settings</translate></b-nav-item>
    <b-nav-item v-if="isMoova" :to="{name: 'company-invoices'}"><translate>Invoices</translate></b-nav-item>
    <b-nav-item :to="{name: 'users'}"><translate>Users Management</translate></b-nav-item>
    <b-nav-item v-if="!isSelfService" :to="{name: 'stores'}"><translate>Stores Management</translate></b-nav-item>
    <b-nav-item v-if="!isSelfService" :to="{name: 'system-notifications'}"><translate>System Notifications</translate></b-nav-item>
    <b-nav-item v-if="hasCompany && !isSelfService" :to="{name: 'company-integrations'}"><translate>Integrations</translate></b-nav-item>
    <b-nav-item v-if="hasCompany && !isSelfService" :to="{name: 'company-api'}"><translate>API/Webhook</translate></b-nav-item>
  </b-nav>
</template>

<script>
export default {
  name: 'CompanyNavigation',
  computed: {
    hasCompany() {
      return this.$store.getters.profile.company_id !== null
    },
    isMoova() {
      return this.$eid === 1 && window.countries.find(x => x.iso_code === window.country).name.toLowerCase().indexOf('saas') === -1
    }
  }
}
</script>
